export function DocumentsPage () {
  return (
    <div>
      <h1 className='heading-lg mb-6'>Documents</h1>
    </div>
  )
}
